import api from './api';

const BASE = '/api/finance';

// startDate/endDate (AD 'YYYY-MM-DD') are optional — when a caller already knows its own true
// period boundaries (e.g. Reports.jsx's BS-aware range), they override the computed
// month/year window for income/expenses/net; month/year/calendar still drive the label + trend.
export const getFinanceSummary = (month, year, calendar, startDate, endDate) => {
  const params = new URLSearchParams();
  if (month !== undefined) params.append('month', month);
  if (year !== undefined) params.append('year', year);
  if (calendar) params.append('calendar', calendar);
  if (startDate) params.append('startDate', startDate);
  if (endDate) params.append('endDate', endDate);
  return api.get(`${BASE}/summary?${params.toString()}`);
};

export const getYearlyBreakdown = (year, calendar) => {
  const params = new URLSearchParams();
  if (year !== undefined) params.append('year', year);
  if (calendar) params.append('calendar', calendar);
  return api.get(`${BASE}/yearly?${params.toString()}`);
};

export const getForecast = (calendar) => {
  const params = new URLSearchParams();
  if (calendar) params.append('calendar', calendar);
  return api.get(`${BASE}/forecast?${params.toString()}`);
};

// ── Business Transaction Ledger (Stage 1) — read-only ────────────────────────────
// start/end are inclusive Kathmandu day strings "YYYY-MM-DD"; omit to default to this month.
export const getLedger = ({ start, end } = {}) => {
  const params = new URLSearchParams();
  if (start) params.append('start', start);
  if (end) params.append('end', end);
  const qs = params.toString();
  return api.get(`${BASE}/ledger${qs ? `?${qs}` : ''}`);
};

// ── Other Income (Stage 3) — non-student income ──────────────────────────────────
export const recordOtherIncome = (data) => api.post(`${BASE}/other-income`, data);
export const voidOtherIncome   = (id, reason) => api.post(`${BASE}/other-income/${id}/void`, { reason });

// ── Receivables (Phase 7) ───────────────────────────────────────────────────────
export const getReceivables = () => api.get(`${BASE}/receivables`);

export const getWrittenOff = () => api.get(`${BASE}/receivables/written-off`);

export const restoreReceivable = (feePaymentId) =>
  api.post(`${BASE}/receivables/${feePaymentId}/restore`);

export const sendReceivableReminder = (feePaymentId, force = false) =>
  api.post(`${BASE}/receivables/${feePaymentId}/remind`, force ? { force: true } : {});

export const waiveReceivable = (feePaymentId, reason) =>
  api.post(`${BASE}/receivables/${feePaymentId}/waive`, { reason });

export const sendBulkReminders = (bucket) =>
  api.post(`${BASE}/receivables/bulk-remind`, { bucket });

export const getAutoReminderStatus = () =>
  api.get(`${BASE}/receivables/auto-reminder-status`);
